import React, {Component} from 'react';
import classNames from 'classnames';

class FileUpload extends Component {
  get files() {
    return this.refs.input.files;
  }

  get form() {
    return this.refs.form;
  }

  clear() {
    this.refs.input.value = '';
  }

  className() {
    return classNames('ds-btn _file', this.props.className);
  }

  render() {
    const {buttonText, onClick, ...restOfProps} = this.props;

    return (
      <section className="cardSection _noBorder">
        <form
          ref="form"
          encType="multipart/form-data"
          className="ds-btn _file -secondary --small">
          <input
            data-test='upload-file-input'
            data-testid='upload-file-input'
            id={this.props.name}
            ref="input"
            type="file"
            {...restOfProps}
            onClick={onClick}
          />
          <i className="materialIcon --micro">cloud_upload</i>
          {this.props.buttonText}
        </form>
        <p className="byline _alignCenter" style={{whiteSpace: 'pre-line'}}> {this.props.tip} </p>
      </section>
    );
  }
}

FileUpload.defaultProps = {
  multiple: false,
  name: 'file_upload',
  accept: 'image/*,application/pdf',
  buttonText: 'Upload Photos or PDF',
  tip: 'Files with less than 25MB in file size are accepted',
  onClick: () => {},
};

export default FileUpload;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/FileUpload.js